import { useEffect, useRef } from "react";
import axios from "axios";
import { API } from "../components/app/constants";

export const AuthCallback = ({ onUserCreated, onNavigate }) => {
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processSession = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        onNavigate("/start");
        return;
      }
      
      const sessionId = match[1];
      const urlParams = new URLSearchParams(window.location.search);
      const referralCode = urlParams.get("ref");
      const buyParam = urlParams.get("buy");
      
      try {
        const response = await axios.post(`${API}/auth/google-session`, { 
          session_id: sessionId,
          referral_code: referralCode || undefined
        });
        onUserCreated(response.data);
        window.history.replaceState(null, "", window.location.pathname);
        onNavigate(buyParam ? `/pricing?buy=${buyParam}` : "/hub");
      } catch {
        onNavigate("/start");
      }
    };
    
    processSession();
  }, [onUserCreated, onNavigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" />
        <p className="text-white/60 text-sm">Signing you in...</p>
      </div>
    </div>
  );
};


